module.exports = __webpack_public_path__ + "img/16.af8b2972.jpg";